// libs/axiosDownload.js
import axios from 'axios'
import { fetchAuthSession } from 'aws-amplify/auth'

const createDownloadInstance = baseURL => {
    const instance = axios.create({
        headers: { 'Content-Type': 'application/json' },
        baseURL,
    })

    instance.interceptors.request.use(async config => {
        if (config.skipAuth) {
            return config
        }

        // Sin forceRefresh: Amplify ya renueva el idToken cuando está por vencer.
        // Ver el comentario largo en libs/axios.js.
        const { tokens } = await fetchAuthSession().catch(() => ({}))
        const idToken = tokens?.idToken

        if (idToken) {
            config.headers.Authorization = `Bearer ${idToken.toString()}`
        }

        return config
    })

    // ✅ Este interceptor NO transforma la respuesta
    // Retorna la respuesta completa para poder acceder a response.data (el blob)
    instance.interceptors.response.use(
        res => res, // Retornar respuesta completa
        error => { throw error }
    )

    return instance
}

export default createDownloadInstance
